"use strict";

require("babel-polyfill");

require("unfetch/polyfill");


//////////////////
// WEBPACK FOOTER
// ./node_modules/catalog/dist/cli/config/polyfills.js
// module id = 291
// module chunks = 1